import { render } from "./ApartmentsList.vue?vue&type=template&id=0e122ccc&scoped=true"
import script from "./ApartmentsList.vue?vue&type=script&lang=js"
export * from "./ApartmentsList.vue?vue&type=script&lang=js"

import "./ApartmentsList.vue?vue&type=style&index=0&id=0e122ccc&lang=scss&scoped=true"

import exportComponent from "/builds/intratone/interface/intratoneinfov4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e122ccc"]])

export default __exports__